import {
  zSchema,
  schemes,
  depositRuleResponseSchema,
  EDepositRuleType,
} from "@zeal/common";

const depositRuleRequestSchema = zSchema.object({
  priority: zSchema.number().int().min(1),
  type: zSchema.nativeEnum(EDepositRuleType),
  amount: zSchema.number().min(1).optional(),
  percentage: zSchema.number().min(1).max(100).optional(),
  bankAccountID: zSchema.string(),
});

export const postDepositRuleRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  workerID: schemes.mongoObjectId(),
  rules: zSchema.array(depositRuleRequestSchema).min(1),
});

export type TPostDepositRuleRequestSchema = zSchema.infer<
  typeof postDepositRuleRequestSchema
>;

export const postDepositRuleResponseSchema = zSchema.object({
  ruleID: schemes.uuid(),
  companyID: schemes.companyID(),
  workerID: schemes.mongoObjectId(),
  rules: zSchema.array(depositRuleResponseSchema),
});

export type TPostDepositRuleResponseSchema = zSchema.infer<
  typeof postDepositRuleResponseSchema
>;
